// Vendorizado de @lai/capability-registry (registry.ts), porém BROWSER-SAFE: sem node:fs.
// O front nunca lê arquivo do disco do back — recebe o catálogo já carregado (HTTP/asset).
// Fonte canônica do catálogo: contracts/capabilities/lai-disk-capabilities.json (sem PII).

export interface Capability {
  id: string;
  slug: string;
  title: string;
  surface_owner: string;
  status: string; // READY_BACKEND | READY | READY_CONTRACT_ONLY | NEEDS_BACKEND | ...
  risk_level: string;
  requires_hitl: boolean;
  external_ci_required: boolean;
  backend_endpoint_expected: string | null;
  anti_placebo_rule: string;
}

export interface CapabilityCatalog {
  version: number;
  count: number;
  capabilities: Capability[];
}

// status que significam "tem backend REAL pronto" -> ação pode ficar habilitada no front.
const BACKEND_READY = new Set(["READY_BACKEND", "READY"]);

export class CapabilityRegistry {
  private byId: Map<string, Capability>;

  constructor(private readonly catalog: CapabilityCatalog) {
    this.byId = new Map(catalog.capabilities.map((c) => [c.id, c]));
  }

  // Substitui o fromFile() do back (que usava node:fs). Aqui o catálogo já vem desserializado.
  static fromCatalog(catalog: CapabilityCatalog): CapabilityRegistry {
    return new CapabilityRegistry(catalog);
  }

  // GET /capabilities -> projeção mínima {capability_id, surface_owner, status, backend_ready}.
  list(): Array<{
    capability_id: string;
    surface_owner: string;
    status: string;
    backend_ready: boolean;
  }> {
    return this.catalog.capabilities.map((c) => ({
      capability_id: c.id,
      surface_owner: c.surface_owner,
      status: c.status,
      backend_ready: this.backendReady(c.id),
    }));
  }

  get(id: string): Capability | null {
    return this.byId.get(id) ?? null; // desconhecido => null
  }

  backendReady(id: string): boolean {
    const c = this.byId.get(id);
    return !!c && BACKEND_READY.has(c.status);
  }

  count(): number {
    return this.catalog.capabilities.length;
  }
}
